/**
 * Created by Sale on 10/28/2024
 */
import {Role} from "@/utils/utils";
import dataProcessingPage from "@/modules/data-processing-module/views/data-processing-page/data-processing-page.vue";
import videoCalibrationPage
    from "@/modules/data-processing-module/views/video-calibration-page/video-calibration-page.vue";
import autoValidationReviewPage
    from "@/modules/data-processing-module/views/auto-validation-review-page/auto-validation-review-page.vue";
import importDataValidationPage
    from "@/modules/data-processing-module/views/import-data-validation-page/import-data-validation-page.vue";

const Module = () => import("./Module.vue");

const moduleRoute = {
    path: "/data-processing",
    component: Module,
    children: [
        {
            path: '/',
            name: 'data-processing',
            meta: {
                product: 'Realite Admin',
                title: 'Data Processing',
                isSubCategory: false,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:get-report',
                topBarTitle: '',
                menuPriority: 6,
                hasMenu: true,
                hasInternalTransition: false
            },
            component: dataProcessingPage
        },
        {
            path: '/video-calibration/:projectId?/:dataDeviceId?',
            name: 'video-calibration',
            meta: {
                product: 'Realite Admin',
                title: 'Video Calibration',
                isSubCategory: true,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:list-video-calibrations',
                topBarTitle: 'Video Calibration',
                menuPriority: 6,
                hasMenu: true,
                hasInternalTransition: false
            },
            props: true,
            component: videoCalibrationPage
        },
        {
            path: '/auto-validation-review/:projectId?/:dataDeviceId?/:dataType?',
            name: 'auto-validation-review',
            meta: {
                product: 'Realite Admin',
                title: 'Auto Validation Review',
                isSubCategory: true,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:get-report',
                topBarTitle: 'Auto Validation Review',
                menuPriority: 6,
                hasMenu: true,
                hasInternalTransition: false
            },
            props: true,
            component: autoValidationReviewPage
        },
        {
            path: '/import-data-validation/:projectId?/:dataDeviceId?',
            name: 'import-data-validation',
            meta: {
                product: 'Realite Admin',
                title: 'Import Data Validation',
                isSubCategory: true,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:get-report',
                topBarTitle: 'Import Data Validation',
                menuPriority: 6,
                hasMenu: true,
                hasInternalTransition: false
            },
            props: true,
            component: importDataValidationPage
        },
    ]
};

export default router => {
    router.addRoutes([moduleRoute]);
};
